import { render, staticRenderFns } from "./SchoolSearchSelect.vue?vue&type=template&id=bfdf1eaa"
import script from "./SchoolSearchSelect.vue?vue&type=script&lang=js"
export * from "./SchoolSearchSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfdf1eaa')) {
      api.createRecord('bfdf1eaa', component.options)
    } else {
      api.reload('bfdf1eaa', component.options)
    }
    module.hot.accept("./SchoolSearchSelect.vue?vue&type=template&id=bfdf1eaa", function () {
      api.rerender('bfdf1eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/SchoolSearchSelect.vue"
export default component.exports